package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.pager.PagerDefaults
import androidx.compose.foundation.pager.VerticalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import kotlinx.coroutines.launch
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSearchBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PlatformStatusBarAppearance
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Joke
import diana.soleil.design.iraniancanadienbazzar.core.model.JokeCategory
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_adult_chip
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_cat_classic
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_cat_family
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_cat_nostalgia
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_cat_observational
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_cat_wordplay
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_copied
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_copy_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_error
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_all
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_jokes_counter
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_jokes_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_jokes_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_jokes_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_like_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_more_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_action
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_search_close_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_search_open_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_message
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_swipe_hint
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/** Stateful entry for the jokes browser (`/gems/jokes`). */
@Composable
fun JokesRoute(
    onBack: () -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    /** Open on this joke (daily-gem push); null starts at the first card. */
    focusJokeId: String? = null,
    viewModel: JokesViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    val lang = AppTheme.language

    // Guest tapped like — consume the gate and route to sign-in (feed pattern).
    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            viewModel.consumeSignInGate()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == GemReportStatus.SignInRequired) {
            viewModel.resetReport()
            onRequireSignIn()
        }
    }

    val shareTemplate = stringResource(Res.string.gems_share_message)
    JokesScreen(
        state = state,
        onBack = onBack,
        onSelectCategory = viewModel::setCategory,
        onSelectAdultTier = viewModel::onAdultTierRequested,
        onSelectCleanTier = viewModel::onCleanTierSelected,
        onQueryChange = viewModel::onQueryChange,
        onToggleLike = viewModel::toggleLike,
        onToggleSave = viewModel::toggleSave,
        onShare = { joke ->
            shareService.share(
                shareTemplate
                    .replace("%1\$s", joke.text.resolve(lang))
                    .replace("%2\$s", shareConfig.jokeLink(joke.id)),
            )
        },
        onReport = viewModel::report,
        onResetReport = viewModel::resetReport,
        onConfirmAdult = viewModel::confirmAdultOptIn,
        onDismissAgeGate = viewModel::dismissAgeGate,
        modifier = modifier,
        focusJokeId = focusJokeId,
    )
}

/**
 * Jokes & Humor swipe reader — Stitch `02356d62fec7406f9dced55ef4c46ed3`: full-screen vertical
 * pager (one joke per page), quote ornament + big centered text, right-edge action rail
 * (like/save/copy/share/report), category chip row, expanding search, "12/124" counter and a
 * swipe-up hint. Double-tap the card to like. Start/end layout only — the rail mirrors in RTL.
 */
@Composable
fun JokesScreen(
    state: JokesUiState,
    onBack: () -> Unit,
    onSelectCategory: (JokeCategory?) -> Unit,
    onSelectAdultTier: () -> Unit,
    onSelectCleanTier: () -> Unit,
    onQueryChange: (String) -> Unit,
    onToggleLike: (jokeId: String, liked: Boolean) -> Unit,
    onToggleSave: (jokeId: String) -> Unit,
    onShare: (Joke) -> Unit,
    onReport: (jokeId: String, reason: String) -> Unit,
    onResetReport: () -> Unit,
    onConfirmAdult: () -> Unit,
    onDismissAgeGate: () -> Unit,
    modifier: Modifier = Modifier,
    focusJokeId: String? = null,
) {
    val lang = AppTheme.language
    val clipboard = LocalClipboardManager.current
    val snackbarHostState = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val copiedMessage = stringResource(Res.string.gems_copied)
    var searchOpen by remember { mutableStateOf(false) }
    var reportJokeId by remember { mutableStateOf<String?>(null) }
    // Jump to the pushed joke once, the first time it is in the list — later swipes stay the user's.
    var focusConsumed by remember(focusJokeId) { mutableStateOf(focusJokeId == null) }

    // The band behind the status bar is brand teal (Stitch) — light icons while we're here.
    PlatformStatusBarAppearance(lightIcons = true)

    Box(modifier = modifier.fillMaxSize().background(AppTheme.colors.surfaceContainer)) {
        Column(modifier = Modifier.fillMaxSize()) {
            // ── Brand band: back + title + expanding search.
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.brandBand)
                    .statusBarsPadding().navigationBarsPadding(),
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    AppIconButton(
                        iconName = "arrow_back",
                        contentDescription = stringResource(Res.string.gems_back_a11y),
                        onClick = onBack,
                        tint = AppTheme.colors.onPrimary,
                    )
                    Text(
                        text = stringResource(Res.string.gems_jokes_title),
                        style = AppTheme.typography.headlineMd,
                        color = AppTheme.colors.onPrimary,
                        modifier = Modifier.weight(1f),
                    )
                    AppIconButton(
                        iconName = if (searchOpen) "close" else "search",
                        contentDescription = stringResource(
                            if (searchOpen) Res.string.gems_search_close_a11y else Res.string.gems_search_open_a11y,
                        ),
                        onClick = {
                            if (searchOpen) onQueryChange("")
                            searchOpen = !searchOpen
                        },
                        tint = AppTheme.colors.onPrimary,
                    )
                }
                if (searchOpen) {
                    AppSearchBar(
                        value = state.query,
                        onValueChange = onQueryChange,
                        placeholder = stringResource(Res.string.gems_search_placeholder),
                        leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
                        modifier = Modifier
                            .padding(horizontal = AppTheme.spacing.lg)
                            .padding(bottom = AppTheme.spacing.md),
                    )
                }
            }

            // ── Category chips (All / genres / gated Adult tier).
            JokeCategoryChips(
                state = state,
                onSelectCategory = onSelectCategory,
                onSelectAdultTier = onSelectAdultTier,
                onSelectCleanTier = onSelectCleanTier,
            )

            when {
                state.loading -> LoadingState()
                // Live snapshot streams reconnect on their own — no manual retry affordance.
                state.error -> EmptyState(title = stringResource(Res.string.gems_error))
                state.jokes.isEmpty() -> EmptyState(
                    title = stringResource(Res.string.gems_jokes_empty_title),
                    description = stringResource(Res.string.gems_jokes_empty_desc),
                )
                else -> {
                    val pagerState = rememberPagerState(pageCount = { state.jokes.size })
                    LaunchedEffect(focusJokeId, state.jokes) {
                        if (focusConsumed) return@LaunchedEffect
                        val index = state.jokes.indexOfFirst { it.id == focusJokeId }
                        if (index >= 0) {
                            pagerState.scrollToPage(index)
                            focusConsumed = true
                        }
                    }
                    Box(modifier = Modifier.weight(1f)) {
                        VerticalPager(
                            state = pagerState,
                            modifier = Modifier.fillMaxSize(),
                            // QA 2026-09-12: the default pager wants the card dragged past half the
                            // screen before it flips, which is a long haul on a full-bleed reader.
                            // A fifth of the page is enough to commit — a flick still works, and a
                            // short drag no longer springs back.
                            flingBehavior = PagerDefaults.flingBehavior(
                                state = pagerState,
                                snapPositionalThreshold = JOKE_SNAP_THRESHOLD,
                            ),
                        ) { page ->
                            val joke = state.jokes[page]
                            JokePage(
                                joke = joke,
                                gradientKey = page,
                                counter = stringResource(
                                    Res.string.gems_jokes_counter,
                                    lang.formatCount(page + 1),
                                    lang.formatCount(state.jokes.size),
                                ),
                                categoryLabel = joke.category.label(),
                                liked = joke.id in state.likedJokeIds,
                                saved = joke.id in state.savedJokeIds,
                                onDoubleTapLike = {
                                    if (joke.id !in state.likedJokeIds) onToggleLike(joke.id, false)
                                },
                                onToggleLike = { onToggleLike(joke.id, joke.id in state.likedJokeIds) },
                                onToggleSave = { onToggleSave(joke.id) },
                                onCopy = {
                                    clipboard.setText(AnnotatedString(joke.text.resolve(lang)))
                                    scope.launch { snackbarHostState.showSnackbar(copiedMessage) }
                                },
                                onShare = { onShare(joke) },
                                onMore = { reportJokeId = joke.id },
                            )
                        }
                        // Swipe hint pinned under the pager (hidden on the last page).
                        if (pagerState.currentPage < state.jokes.size - 1) {
                            Column(
                                modifier = Modifier
                                    .align(Alignment.BottomCenter)
                                    .padding(bottom = AppTheme.spacing.md),
                                horizontalAlignment = Alignment.CenterHorizontally,
                            ) {
                                Text(
                                    text = stringResource(Res.string.gems_swipe_hint),
                                    style = AppTheme.typography.labelSm,
                                    color = AppTheme.colors.onSurfaceVariant,
                                )
                                AppIcon(
                                    name = "keyboard_arrow_up",
                                    size = AppTheme.sizes.iconSm,
                                    tint = AppTheme.colors.onSurfaceVariant,
                                )
                            }
                        }
                    }
                }
            }
        }
        SnackbarHost(
            hostState = snackbarHostState,
            modifier = Modifier.align(Alignment.BottomCenter),
        )
    }

    // ── Age gate (Stitch 0365dbc1) — only reachable while the RC tier flag is on.
    if (state.showAgeGate) {
        AgeGateSheet(onConfirm = onConfirmAdult, onDismiss = onDismissAgeGate)
    }

    // ── Report sheet (existing moderation flow; targetType "joke").
    reportJokeId?.let { jokeId ->
        ReportSheet(
            title = stringResource(Res.string.gems_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.gems_report_reason_offensive), "offensive"),
                ReportReason(stringResource(Res.string.gems_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.gems_report_reason_other), "other"),
            ),
            status = when (state.reportStatus) {
                GemReportStatus.Sending -> ReportStatus.Sending
                GemReportStatus.Sent -> ReportStatus.Sent
                GemReportStatus.Failed -> ReportStatus.Failed
                else -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.gems_report_sent),
            failedText = stringResource(Res.string.gems_report_failed),
            submitText = stringResource(Res.string.gems_report_submit),
            doneText = stringResource(Res.string.gems_report_done),
            onSubmit = { reason -> onReport(jokeId, reason) },
            onDismiss = {
                reportJokeId = null
                onResetReport()
            },
        )
    }
}

/** Category chip rail; the Adult chip exists only while `gems_adult_jokes_enabled` is on. */
@Composable
private fun JokeCategoryChips(
    state: JokesUiState,
    onSelectCategory: (JokeCategory?) -> Unit,
    onSelectAdultTier: () -> Unit,
    onSelectCleanTier: () -> Unit,
) {
    val categories = remember { JokeCategory.entries.toList() }
    LazyRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        contentPadding = androidx.compose.foundation.layout.PaddingValues(
            horizontal = AppTheme.spacing.lg,
            vertical = AppTheme.spacing.md,
        ),
    ) {
        item("all") {
            AppChip(
                label = stringResource(Res.string.gems_filter_all),
                selected = state.category == null && !state.adultTier,
                onClick = {
                    onSelectCleanTier()
                    onSelectCategory(null)
                },
            )
        }
        items(categories, key = { it.name }) { category ->
            AppChip(
                label = category.label(),
                selected = state.category == category && !state.adultTier,
                onClick = {
                    onSelectCleanTier()
                    onSelectCategory(category)
                },
            )
        }
        if (state.adultTierAvailable) {
            item("adult") {
                AppChip(
                    label = stringResource(Res.string.gems_adult_chip),
                    selected = state.adultTier,
                    leadingIcon = "explicit",
                    onClick = {
                        if (state.adultTier) onSelectCleanTier() else onSelectAdultTier()
                    },
                )
            }
        }
    }
}

/** One pager page: a full-bleed gradient story card ([GemStoryCard]) with the joke. */
@Composable
private fun JokePage(
    joke: Joke,
    gradientKey: Int,
    counter: String,
    categoryLabel: String,
    liked: Boolean,
    saved: Boolean,
    onDoubleTapLike: () -> Unit,
    onToggleLike: () -> Unit,
    onToggleSave: () -> Unit,
    onCopy: () -> Unit,
    onShare: () -> Unit,
    onMore: () -> Unit,
) {
    val lang = AppTheme.language
    GemStoryCard(
        key = joke.id,
        gradient = AppTheme.gradients.storyCard(gradientKey),
        watermark = "format_quote",
        counter = counter,
        categoryLabel = categoryLabel,
        text = joke.text.resolve(lang),
        likeCount = joke.likeCount,
        liked = liked,
        saved = saved,
        onDoubleTapLike = onDoubleTapLike,
        onToggleLike = onToggleLike,
        onToggleSave = onToggleSave,
        onCopy = onCopy,
        onShare = onShare,
        onMore = onMore,
    )
}

/** Localized display label for a joke genre (app chrome, never content). */
@Composable
internal fun JokeCategory.label(): String = stringResource(
    when (this) {
        JokeCategory.Classic -> Res.string.gems_cat_classic
        JokeCategory.Wordplay -> Res.string.gems_cat_wordplay
        JokeCategory.Family -> Res.string.gems_cat_family
        JokeCategory.Nostalgia -> Res.string.gems_cat_nostalgia
        JokeCategory.Observational -> Res.string.gems_cat_observational
    },
)

/** How far a joke card must be dragged before it commits to the next one (fraction of the page). */
private const val JOKE_SNAP_THRESHOLD = 0.2f
